<mat-card class="login-card">
  <div class="card-header">
    <h1 class="title">Faça o seu cadastro</h1>
    <h2>Para acessar o portal, é preciso realizar o cadastro.</h2>
  </div>

  <div class="card-content">
    <button 
      type="button"
      mat-flat-button
      (click)="redirectPrimeiroAcesso()"
      class="btn-continue">
      Primeiro acesso
    </button>
  </div>
</mat-card>